import React from 'react'
export default class Index extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div ref="loadMore" style={{width:'100%',height:this.props.height || '0.8rem',lineHeight:this.props.height || '0.8rem',textAlign:'center',fontSize:'14px',color:'#777'}}>加载中...</div>
        )
    }
    
    componentDidMount() {
        let timeout

        const {loadMoreData} = this.props;
        let loadMore = this.refs.loadMore
        function callBack() {
            const top = loadMore.getBoundingClientRect().top;
            const windowHeight = window.screen.height;
            let addHeight = 50
            //灵敏度不够的手机 增加50px的判断距离
            if(top && top <windowHeight + addHeight ) {
                loadMoreData();
            }
        }
        setTimeout(()=>{callBack();},50);
        window.addEventListener("scroll",() => {
            if(timeout){
                clearTimeout(timeout)
            }
            timeout=setTimeout(callBack,50)
        },false)
    }
}